// src/data/projectsData.js

//project 1
import paymentImg1 from "../pages/assets/images/project1/paymentsnew.png";
import paymentImg2 from "../pages/assets/images/project1/img2.png";
//project 2
import project2Img1 from "../pages/assets/images/project2/img1.png";
import project2Img2 from "../pages/assets/images/project2/img2.png";    
// Import additional project images as needed
//project 3
import project3Img1 from "../pages/assets/images/project3/img1.png";
const projectsData = [
  { //1st project
    id: "1",
    name: "Custom Payments PAGE",
    description: "An amazing app for payments using URLs.",
    images: [paymentImg1, paymentImg2],
    liveLink: "http://pay.rpx.unaux.com?am=100",
    technologies: {
      Frontend: ['HTML', 'CSS'],
      Backend: ['JavaScript'],
      Assets: ['Payment Gateway Images', 'Payment Gateway URLs'],
      Hosting: ['PROFREEHOST']
    }
  },
  { //2nd project
    id: "2",
    name: "Manual Entry Payments PAGE",
    description: "An amazing app for payments by entering amounts.",
    images: [project2Img1, project2Img2],
    liveLink: "http://pay.rpx.unaux.com/norpay.html",
    technologies: {
      Frontend: ['HTML', 'CSS'],
      Backend: ['JavaScript'],
      Assets: ['Payment Gateway Images', 'Payment Gateway URLs'],
      Hosting: ['PROFREEHOST']
    }
  },
  { //3rd project
    id: "3",
    name: "100 - C PROGRAMS",
    description: "An amazing collection of 100 C programs from beginner to Pro.",
    images: [project3Img1],
    githubLink: "https://github.com/ramswarooppatel/c_programming",
    technologies: {
      Frontend: ['C'],
      Backend: ['C']
    }
  }
 
  // Add more projects as needed
];

export default projectsData;